import * as tslib_1 from "tslib";
import { Component } from "vue-property-decorator";
import { DateInputControl } from "../../controls";
import { H3Input, H3Datetime } from "h3-mobile-vue";
import { dateFormatter } from '@cloudpivot/form/utils/date-formatter';
import TimeRangesSelect from "./time-ranges-select.vue";
import ControlBack from "../../directives/control-back";
import moment from 'moment';
const isiOS = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // 判断是否ios终端
let InputTimeRange = class InputTimeRange extends DateInputControl {
    constructor() {
        super(...arguments);
        this.showModals = [false, false];
        this.visible = false;
    }
    show(index) {
        this.showModals.splice(index, 1, true);
    }
    close(index) {
        this.showModals.splice(index, 1, false);
    }
    onConfirm(index, value) {
        const vals = this.ctrl.value.map((x) => x);
        vals[index] = value;
        this.ctrl.value = vals;
    }
    change(val) {
        if (this.ctrl.value && this.ctrl.value.length > 1) {
            this.ctrl.value[0] = this.dateFormat(val.start.format(this.format));
            this.ctrl.value[1] = this.dateFormat(val.end.format(this.format));
            this.ctrl.value = this.ctrl.value.slice(0); //触发计算属性更新
        }
    }
    get begin() {
        if (this.ctrl.value && this.ctrl.value.length > 1) {
            const val = this.ctrl.value[0];
            if (moment.isMoment(val)) {
                return val.format(this.format || "HH:mm:ss");
            }
            else if (typeof (val) === 'string') {
                return val;
            }
        }
        return "";
    }
    get end() {
        if (this.ctrl.value && this.ctrl.value.length === 2) {
            const val = this.ctrl.value[1];
            if (moment.isMoment(val)) {
                return val.format(this.format || "HH:mm:ss");
            }
            else if (typeof (val) === 'string') {
                return val;
            }
        }
        return "";
    }
    get beginLabel() {
        return this.control.options.name + '开始';
    }
    get endLabel() {
        return this.control.options.name + '结束';
    }
    dateFormat(val) {
        let date;
        let ymd = '1970-01-01 ';
        if (isiOS) {
            date = new Date(`${ymd}${val}`.replace(/-/g, '/'));
        }
        else {
            date = new Date(`${ymd}${val}`.replace(/-s/g, 'T'));
        }
        return dateFormatter(date, this.format || 'HH:mm:ss');
    }
    clearVal(index) {
        // ;
        this.ctrl.value[index] = '';
        this.ctrl.value = [...this.ctrl.value];
        // this.val =  '';
        // this.ctrl.value = null;
    }
};
InputTimeRange = tslib_1.__decorate([
    Component({
        name: "input-time-range",
        components: {
            H3Input,
            H3Datetime,
            TimeRangesSelect
        },
        directives: {
            ControlBack
        }
    })
], InputTimeRange);
export default InputTimeRange;
